import AppSkeleton from './AppSkeleton.vue'

export default AppSkeleton
